<template>
    <div v-if="notes" v-html="notes" />

    <div v-else>
        <em class="text-muted" v-text="$t('common.not-available')" />
    </div>
</template>

<script>
export default {
    name: 'NotesLabel',

    props: {
        notes: {type: String, default: null},
    },
};
</script>
